export default {
  contributions: {
    current: null,
    goal: null,
  },
  siteType: "General",
  toolbarSearchText: ""
};
